import {UniqueIdGeneratorInstanceType, UniqueIdGeneratorType} from './types';

const errors = {
    methodNotExist: (name: string) => `${name} method does not exists on idGenerator instance`,
};

/**
 * UniqueIdGenerator is interface for generateId usage
 * @param {UniqueIdGeneratorInstanceType} idGenerator instance of usage realization
 */
class UniqueIdGenerator implements UniqueIdGeneratorType {
    idGenerator: UniqueIdGeneratorInstanceType;

    /**
     * UniqueIdGenerator constructor
     * @param {UniqueIdGeneratorInstanceType} idGenerator - realization instance
     */
    constructor(idGenerator: UniqueIdGeneratorInstanceType) {
        if (!idGenerator) {
            throw new Error('UniqueIdGenerator cannot use without idGenerator instance');
        }
        this.idGenerator = idGenerator;
    }

    /**
     * Generate unique id method which calls idGenerator realization
     * @param {number} size length of returns id
     * @returns {string} id
     */
    generateId(size = 22) {
        if (!this.idGenerator?.generateId) throw new TypeError(errors.methodNotExist('generateId'));

        return this.idGenerator.generateId(size);
    }
}

export default UniqueIdGenerator;
